<template>
    <modal :id="`delete-file-modal-${id}`" class-name="delete-file-modal">
        <template slot="title">Delete File</template>
        <template slot="body">
            <table class="table">
                <tbody>
                <tr>
                    <th>Name</th>
                    <td v-text="file.name"></td>
                </tr>
                <tr>
                    <th>Type</th>
                    <td v-text="file.type"></td>
                </tr>
                <tr v-if="file.size">
                    <th>Size</th>
                    <td v-text="prettyBytes(file.size)"></td>
                </tr>
                <tr>
                    <th>Uploaded By</th>
                    <td v-text="file.owner.name"></td>
                </tr>
                <tr>
                    <th>Uploaded Date</th>
                    <td v-text="shortDate(file.created_at)"></td>
                </tr>
                </tbody>
            </table>
        </template>
        <template slot="footer">
            <submit-button :form="form" class="btn-danger" icon="fa-times" processing-text="Deleting..." @click="save()">Delete</submit-button>
        </template>
    </modal>
</template>
<script>
    export default {

        props: {
            file: {
                type: Object,
                required: true,
            },
            id: {
                type: Number,
                required: false,
                default: '',
            }
        },

        data(){
            return {
                form: new Form({}),
            }
        },

        methods:{
            save() {
                this.form.delete(`/admin/files/${this.file.id}`).then(response => {
                    this.closeModal(`delete-file-modal-${this.id}`)
                    this.$emit('deleted', this.file);
                    Toast.success('File deleted successfully!')
                });
            }
        },
    }
</script>